/**
 * 現在の再生位置と総再生時間から進捗率(0-100)を計算する
 * @param currentTime - 現在の再生位置（秒）
 * @param duration - 総再生時間（秒）
 * @returns 進捗率（0-100）。durationが0の場合は0を返す
 */
const calculateProgress = (currentTime: number, duration: number): number => {
  if (duration === 0) {
    return 0;
  }
  return (currentTime / duration) * 100;
};

export default calculateProgress;
